"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
const Merchant_1 = __importDefault(require("./Merchant"));
exports.default = {
    Client: Client_1.default,
    Merchant: Merchant_1.default,
};
//# sourceMappingURL=index.js.map